import { DictionaryEntity, OperationPoint, operationPoint, PcsEntity } from '@app/pcs/models';
import { PropertyNameMapper } from '@app/shared/forms/property-mapper';
import { TrainId, trainId, trainIdMapper } from '@dossier/models/train-id';
import { gql } from 'apollo-angular';

export interface Connection {
  id?: number;
  dossierId?: number;
  guaranteed?: boolean;
  imComment?: string;
  connectionKindType?: DictionaryEntity;
  connectionText?: string;
  connectingTrainNumber?: string;
  connectingTrainDossierId?: number;
  operationPoint?: OperationPoint;
  sortOrder?: number;
  associatedTrainId?: TrainId;
}

export enum ConnectionAclActionMap {
  AddConnection = 'AddConnection',
  EditConnection = 'EditConnection',
  DeleteConnection = 'DeleteConnection'
}

export const connectionMapper = new PropertyNameMapper({
  imComment: 'imComment',
  guaranteed: 'isGuaranteed',
  connectionKindType: 'connectionKindTypeId',
  operationPoint: 'operationPointId',
  connectionText: 'connectionText',
  associatedTrainId: trainIdMapper
}, {entityName: PcsEntity.Connection});

export const connection = gql`
  fragment connection on Connection {
    id
    dossierId
    guaranteed
    imComment
    connectionKindType {
      id
      description
    }
    connectionText
    connectingTrainNumber
    connectingTrainDossierId
    operationPoint {
      ...operationPoint
    }
    sortOrder
    associatedTrainId {
      ...trainId
    }
  }
  ${operationPoint}
  ${trainId}
`;
